import React, { useCallback } from "react"

import { usePage } from "../../../hooks/usePage"
import { useApp } from "../../../hooks/useApp"

import { useCustomerDetails, useCustomerAddress } from "../../../hooks/useCustomer"

export const withDashboard = Component => ({ name = "Dashboard", location, ...props }: any) => {
  const {
    config: {
      settings: { routes },
    },
    globalStateReducer,
  } = useApp()
  const {
    dashboard: { title, content, additionalGreeting },
  } = usePage()
  const { customer, loading: loadingDetails, errors: detailsError } = useCustomerDetails()
  const { addresses, loading: loadingAddress, errors: addressError } = useCustomerAddress()
  const [{ activeAccount }, dispatch] = globalStateReducer

  const formattedAddress = addresses?.find(addr => addr.default)?.formatted
  const accountDashboardUrl = `${routes.DASHBOARD}`
  const accountDetailsUrl = `${routes.PREFERENCES}`

  const isAccountDetails = location?.pathname?.includes(routes.PREFERENCES)

  const handleClickButton = useCallback(() => {
    dispatch({
      type: "setActiveAccount",
      payload: !activeAccount,
    })
  }, [activeAccount, dispatch])

  Component.displayName = name
  return (
    <Component
      {...props}
      title={title}
      content={content}
      customer={customer}
      formattedAddress={formattedAddress}
      loading={loadingDetails || loadingAddress}
      errors={detailsError || addressError}
      accountDashboardUrl={accountDashboardUrl}
      accountDetailsUrl={accountDetailsUrl}
      isAccountDetails={isAccountDetails}
      handleClickButton={handleClickButton}
      additionalGreeting={additionalGreeting}
    />
  )
}
